import { find } from 'lodash';

interface NewUserProps {
  id: string;
  email: string;
  displayName: string;
  avatarUrl: string | null | undefined;
  memberships: {
    id: string;
    account: {
      id: string;
    };
  }[];
  isAdmin: boolean;
}

export class User {
  public static emptyUser() {
    return new User({
      id: '',
      email: '',
      displayName: '',
      avatarUrl: null,
      memberships: [],
      isAdmin: false
    });
  }
  public id: string;
  public email: string;
  public displayName: string;
  public avatarUrl: string | null | undefined;
  public memberships: {
    id: string;
    account: {
      id: string;
    };
  }[];
  public isAdmin: boolean = false;

  public constructor(props: NewUserProps) {
    this.id = props.id;
    this.email = props.email;
    this.displayName = props.displayName;
    this.avatarUrl = props.avatarUrl;
    this.memberships = props.memberships;
    this.isAdmin = props.isAdmin;
  }

  public memberIdForAccount(accountId: string) {
    const membership = find(this.memberships, m => m.account.id === accountId);
    return membership!.id;
  }
}
